<div class="menu-component-container page-root-container">
        <div class="page-header">
                <div class="page-title">
                        <img class="icon" src="assets/images/menu/svg/customization.svg"><span
                                class="title">Customization</span>
                </div>
                <div class="page-actions">
                        @if(permission.can_add){
                        <button mat-button color="primary" class="btn-add"
                                (click)="addClicked()"><mat-icon>person_add</mat-icon>New</button>
                        }
                        @if(permission.can_export || permission.can_execute){
                        <button mat-button color="accent" class="btn-export" (click)="exportClicked()"
                                [disabled]="IsDownloading">
                                <img class="download-icon"
                                        [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
                                Export
                        </button>
                        }
                </div>
        </div>

        <div class="data-container ">
                <app-loader [show]="isLoading"></app-loader>
                <app-search-filter *ngIf="isFilterReady" #searchFilter [pagingData]="pagingData"
                        [pageSizeOptions]="[5,10,20,50,100]" [filter]="filter" (page)="onePageEvent($event)"
                        (onApply)="onFilterApplied($event)" [hidePageSize]="true">
                </app-search-filter>
                <section tabindex="0" class="table-container">
                        <table matSort mat-table [dataSource]="dataSource">
                                <ng-container matColumnDef="item">
                                        <th mat-header-cell *matHeaderCellDef (click)="sortData($event)"
                                                class="item-header">#</th>
                                        <td mat-cell *matCellDef="let menu; let i = index" class="item-column">{{
                                                (pagingData.pageIndex*pagingData.pageSize) + i + 1 }}</td>
                                </ng-container>
                                <ng-container matColumnDef="code">
                                        <th mat-sort-header="code" mat-header-cell style="width: 80px;"
                                                *matHeaderCellDef (click)="sortData($event)">Code</th>
                                        <td mat-cell *matCellDef="let menu" style="width: 80px;">
                                                {{menu.code}}
                                        </td>
                                </ng-container>

                                <ng-container matColumnDef="name">
                                        <th mat-sort-header="name" style="width:20%" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Name </th>
                                        <td mat-cell *matCellDef="let menu"> {{menu.name}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="display_name">
                                        <th mat-sort-header="display_name" style="width:15%" mat-header-cell
                                                *matHeaderCellDef (click)="sortData($event)"> Display Name </th>
                                        <td mat-cell *matCellDef="let menu"> {{menu.display_name}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="value_name">
                                        <!-- <th mat-sort-header="value_name" mat-header-cell *matHeaderCellDef
                                                (click)="sortData($event)"> Values </th> -->
                                        <th mat-sort-header="value_name" mat-header-cell *matHeaderCellDef> Values </th>
                                        <td mat-cell *matCellDef="let menu"> {{menu.value_name}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="option_for">
                                        <th mat-sort-header="option_for" style="width:15%" mat-header-cell
                                                *matHeaderCellDef (click)="sortData($event)"> Option For </th>
                                        <td mat-cell *matCellDef="let menu"> {{menu.option_for}}
                                        </td>
                                </ng-container>
                                <ng-container matColumnDef="action" stickyEnd>
                                        <th mat-header-cell *matHeaderCellDef> </th>
                                        <td mat-cell class="row-menu-btn" style="width:50px" *matCellDef="let rowItem">
                                                <a mat-icon-button class="row-menu-btn" [matMenuTriggerFor]="rowMenu"
                                                        (click)="onRowSelected(rowItem);$event.stopPropagation();">
                                                        <mat-icon>more_vert</mat-icon>
                                                </a>

                                                <mat-menu #rowMenu>
                                                        @if(permission.can_delete){
                                                        <button mat-menu-item
                                                                (click)="onDelete(rowItem)">Delete</button>
                                                        }
                                                        @if(permission.can_edit){
                                                        <button mat-menu-item (click)="onEdit(rowItem)">Edit</button>
                                                        }
                                                        @else{
                                                        <button mat-menu-item (click)="onEdit(rowItem)">View</button>

                                                        }
                                                        <button mat-menu-item
                                                                (click)="onDuplicate(rowItem)">Duplicate</button>
                                                </mat-menu>
                                        </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true">
                                </tr>
                                <tr mat-row class="table-element-row" *matRowDef="let menu; columns: displayedColumns;"
                                        (click)="onRowSelected(menu)" (dblclick)="onEdit(menu)"
                                        [ngClass]=" {'row-selected' : menu.id===selectedItem?.id}">
                                </tr>
                        </table>
                </section>

                <!-- </ng-container> -->
                <!-- <ng-template #nodata> -->
                @if(pagingData.length<=0){ <div class="no-data-container">
                        <img src="assets/images/no-data.png">
                        <span class="no-data-info">No data found. Please remove or redefine the filters if
                                any.</span>
        </div>
        <!-- </ng-template> -->
        }
</div>

</div>